(function () {
  function ensureDialog() {
    var dlg = document.getElementById('bxbQuickDialog');
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.id = 'bxbQuickDialog';
    dlg.className = 'bxb-qd';
    dlg.innerHTML = '<button type="button" class="bxb-qd__close" aria-label="Close">&times;</button><div class="bxb-qd__body"><p class="bxb-qd__loading">Loading…</p></div>';
    document.body.appendChild(dlg);
    dlg.querySelector('.bxb-qd__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('cancel', function () { dlg.close(); });
    return dlg;
  }

  function openQuickAdd(url) {
    var dlg = ensureDialog();
    var body = dlg.querySelector('.bxb-qd__body');
    body.innerHTML = '<p class="bxb-qd__loading">Loading…</p>';
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.bxb-pdp');
        if (!section) { body.innerHTML = '<p class="bxb-qd__err">Could not load this product. <a href="' + url + '">Open product page</a></p>'; return; }
        var styles = [].slice.call(doc.querySelectorAll('style')).filter(function (s) { return /bxb-pdp-/.test(s.textContent); });
        var script = section.nextElementSibling;
        while (script && script.tagName !== 'SCRIPT') script = script.nextElementSibling;
        body.innerHTML = '';
        styles.forEach(function (s) { body.appendChild(s.cloneNode(true)); });
        body.appendChild(section.cloneNode(true));
        if (script) {
          var sc = document.createElement('script');
          sc.textContent = script.textContent;
          body.appendChild(sc);
        }
      })
      .catch(function () {
        body.innerHTML = '<p class="bxb-qd__err">Could not load this product. <a href="' + url + '">Open product page</a></p>';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bxb-quickadd]');
    if (!btn) return;
    e.preventDefault();
    openQuickAdd(btn.dataset.url);
  });
})();
